import { Deserializable } from '../protocols/deserializable';
import { InvestmentInstructionSubmissionInstructionData } from './investment-instruction-submission-instruction-data';
import { InvestmentInstructionSubmissionAccountRebalancingData } from './investment-instruction-submission-account-rebalancing-data';

export class InvestmentInstructionSubmissionData implements Deserializable {
  public investmentInstructions!: InvestmentInstructionSubmissionInstructionData[];
  public rebalancingInstructions!: InvestmentInstructionSubmissionAccountRebalancingData[];

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;

    if (!!this.investmentInstructions) {
      this.investmentInstructions = Deserialize.arrayOf(
        InvestmentInstructionSubmissionInstructionData,
        this.investmentInstructions
      );
    }

    if (!!this.rebalancingInstructions) {
      this.rebalancingInstructions = Deserialize.arrayOf(
        InvestmentInstructionSubmissionAccountRebalancingData,
        this.rebalancingInstructions
      );
    }
  }
}
